// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  position: fixed; 
  bottom: 0; 
  left: 50%; 
  transform: translateX(-50%); 
  z-index: 1000;
  width: 100%;
  max-width: 420px; 
  background-color: #ffffff;
  border-top: 1px solid #e0e0e0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 8px 0;
  box-sizing: border-box;
}

.footer-link {
  text-align: center;
  text-decoration: none;
  color: #555;
  font-size: 12px;
  flex: 1 1;
}

.footer-link svg {
  display: block;
  margin: 0 auto 4px;
}`, "",{"version":3,"sources":["webpack://./src/Footer.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,6BAA6B;EAC7B,2CAA2C;EAC3C,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,SAAO;AACT;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB","sourcesContent":[".footer {\n  position: fixed; \n  bottom: 0; \n  left: 50%; \n  transform: translateX(-50%); \n  z-index: 1000;\n  width: 100%;\n  max-width: 420px; \n  background-color: #ffffff;\n  border-top: 1px solid #e0e0e0;\n  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  padding: 8px 0;\n  box-sizing: border-box;\n}\n\n.footer-link {\n  text-align: center;\n  text-decoration: none;\n  color: #555;\n  font-size: 12px;\n  flex: 1;\n}\n\n.footer-link svg {\n  display: block;\n  margin: 0 auto 4px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
